"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NftVariable = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _VariableType = require("../VariableType");
class NftVariable extends _VariableType.VarsValueVariableType {
  constructor() {
    super();
    (0, _defineProperty2.default)(this, "settings", NftVariable.settings);
    (0, _defineProperty2.default)(this, "type", "nft");
    (0, _defineProperty2.default)(this, "valueType", "nft");
    (0, _defineProperty2.default)(this, "label", "NFT Item");
    (0, _defineProperty2.default)(this, "description", "Load an NFT item and its metadata.");
  }
  dependencies(params, resolver) {
    let contract = resolver.resolveContract(params.contract);
    let tokenId = resolver.resolveString(params.tokenId);
    return {
      contract,
      tokenId
    };
  }
  async value(deps, batcher) {
    if (!(deps !== null && deps !== void 0 && deps.contract) || !deps.tokenId) {
      return null;
    }
    let metadata = await batcher.getNft(deps.contract, deps.tokenId);
    let record = {
      tokenId: deps.tokenId,
      collection: deps.contract.name
    };
    if (metadata) {
      for (let [key, val] of Object.entries(metadata)) {
        if (key === "attributes") {
          let attr = val;
          let attributes = {};
          let props = [];
          for (let it of attr) {
            if (it.trait_type) {
              attributes[it.trait_type] = it.value;
            } else if (it.value) {
              props.push(it.value);
            }
          }
          if (props.length > 0) {
            attributes.props = props;
          }
          record[key] = attributes;
        } else {
          record[key] = val;
        }
      }
    }
    return record;
  }
}
exports.NftVariable = NftVariable;
(0, _defineProperty2.default)(NftVariable, "settings", {
  contract: {
    type: "var",
    variableType: "contract",
    title: "NFT Contract",
    description: "Contract to load an NFT item from."
  },
  tokenId: {
    type: "var",
    variableType: "value",
    title: "Token ID",
    description: "Token ID of the NFT item to load."
  }
});
//# sourceMappingURL=NftVariable.js.map